/* unplugin-vue-components disabled */
import Column from 'primevue/column'
import {DataTable} from 'components/data-table'
import EditModal from './edit-modal.vue'
import AddModal from './add-modal.vue'
import $shtopics from 'stores/sh-topics'

const LIMIT = 20

export default {
  components: {
    EditModal,
    AddModal,
    DataTable,
    Column
  },
  data() {
    return {
      loading: true,
      load_params: {skip: 0, limit: LIMIT, filter: ''},
    }
  },
  computed: {
    total(){
      return $shtopics.total
    },
    view_items(){
      return $shtopics.view_items
    },
    view_total(){
      return $shtopics.view_total
    },
    refreshing() {
      return $shtopics.loading
    },
    highlight () {
      return this.load_params.filter
    }
  },
  async mounted() {
    this.loading = true
    await $shtopics.load(this.load_params)
    this.loading = false
  },
  methods: {
    async onPage(ev){
      this.load_params = {...this.load_params, skip: ev.first, limit: ev.rows}
      await $shtopics.load(this.load_params)
    },
    async onCopyId(id) {
      await $utils.copyText(id)
    },
    async onSearch(filter){
      if (this.load_params.filter === filter) return
      this.load_params = {skip: 0, limit: LIMIT, filter}
      await $shtopics.load(this.load_params)
      this.$refs.search.focus()
    },
    onAddTopic() {
      this.$refs.addModal.open()
    },
    onEditTopic(id) {
      const shc = $shtopics.getTopic(id)
      this.$refs.editModal.open(shc)
    },
    async onNewTopic(data) {
      try {
        await $shtopics.newTopic(data)
        await $shtopics.load(this.load_params)
        $utils.toasts.success('Topic added successfully')
      }
      catch(err) {
        $utils.toasts.error(`Failed to add topic: ${err}`)
      }
      this.$refs.addModal.close(true)
    },
    async onUpdateTopic(data) {
      const shc = $shtopics.getTopic(data.id)
      const old_name = shc.name

      try {
        shc.name = data.name
        await shc.save()
        $utils.toasts.success('Topic updated successfully')
      }
      catch(err) {
        $utils.toasts.error(`Failed to update topic: ${err}`)
        shc.name = old_name
      }
      this.$refs.editModal.close(true)
    },
  }
}
